var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_778_8199)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.00805664,
    width: 56,
    height: 56,
    rx: 16.8,
    fill: "url(#paint0_linear_778_8199)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_778_8199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.68 15.1281C15.68 13.2724 17.1843 11.7681 19.04 11.7681H37.52C39.3757 11.7681 40.88 13.2724 40.88 15.1281V40.8881C40.88 42.7437 39.3757 44.2481 37.52 44.2481H19.04C17.1843 44.2481 15.68 42.7437 15.68 40.8881V15.1281Z",
    fill: "#F5FAE9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.16 22.9681C20.16 22.3495 20.6614 21.8481 21.28 21.8481H34.72C35.3385 21.8481 35.84 22.3495 35.84 22.9681C35.84 23.5866 35.3385 24.0881 34.72 24.0881H21.28C20.6614 24.0881 20.16 23.5866 20.16 22.9681Z",
    fill: "#95D011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.16 28.0081C20.16 27.3895 20.6614 26.8881 21.28 26.8881H27.44C28.0585 26.8881 28.56 27.3895 28.56 28.0081C28.56 28.6266 28.0585 29.1281 27.44 29.1281H21.28C20.6614 29.1281 20.16 28.6266 20.16 28.0081Z",
    fill: "#95D011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.16 33.048C20.16 32.4295 20.6614 31.928 21.28 31.928H32.48C33.0985 31.928 33.6 32.4295 33.6 33.048C33.6 33.6666 33.0985 34.168 32.48 34.168H21.28C20.6614 34.168 20.16 33.6666 20.16 33.048Z",
    fill: "#95D011"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_778_8199",
    x: -29.12,
    y: 11.7681,
    width: 114.8,
    height: 133.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54966
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.619865
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0196802 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_778_8199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.72406
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.48962
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_778_8199",
    result: "effect2_dropShadow_778_8199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.01207
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.80483
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_778_8199",
    result: "effect3_dropShadow_778_8199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.5083
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0417275 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_778_8199",
    result: "effect4_dropShadow_778_8199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23.3955
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.35818
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0503198 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_778_8199",
    result: "effect5_dropShadow_778_8199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 56
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_778_8199",
    result: "effect6_dropShadow_778_8199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_778_8199",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_778_8199",
    x1: 28,
    y1: 0.00805664,
    x2: 28,
    y2: 56.0081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ED412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC50D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_778_8199"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.00805664,
    width: 56,
    height: 56,
    rx: 16.8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.e81d658eff912d18982b27a9a639b12c.svg";
export { ForwardRef as ReactComponent };